
const HEADER = {
  FLAG_SYNC: 0x01,
  FLAG_FIN: 0x02,
  FLAG_COMPRESSED: 0x04,
  FLAG_LAST: 0x08,
  FLAG_ERROR: 0x10,
}

// Special constant for detect unsync backend and fronend
export const CURRENT_SYNC = false;

export function encodeHeader({ sync, fin, compressed, last, error }) {
  const value = (sync && HEADER.FLAG_SYNC)
    | (fin && HEADER.FLAG_FIN)
    | (compressed && HEADER.FLAG_COMPRESSED)
    | (last && HEADER.FLAG_LAST)
    | (error && HEADER.FLAG_ERROR);
  return value.toString(16);
}

export function decodeHeader(header = '0') {
  const value = parseInt(header, 16);
  return {
    sync: !!(value & HEADER.FLAG_SYNC),
    fin: !!(value & HEADER.FLAG_FIN),
    compressed: !!(value & HEADER.FLAG_COMPRESSED),
    last: !!(value & HEADER.FLAG_LAST),
    error: !!(value & HEADER.FLAG_ERROR),
  }
}